import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=297fc15e&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"
import style0 from "./Invite.vue?vue&type=style&index=0&id=297fc15e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fc15e",
  null
  
)

export default component.exports